import React from 'react';
import './About.css';

const About = () => {
  return (
    <section className="about-section">
      <div className="about-container">
        {/* Left Side - Image with decorative elements */}
        <div className="about-left">
          <div className="decorative-circle"></div>
          <div className="decorative-star"></div>
          <div className="decorative-triangle"></div>
          <div className="about-image-container">
            <img 
              src="/img.png" 
              alt="Event House Team" 
              className="about-main-image"
            />
          </div>
        </div>

        {/* Arrow */}
        <div className="about-arrow">
          <svg width="2" height="225" viewBox="0 0 2 225" fill="none">
            <line x1="1" y1="0" x2="1" y2="225" stroke="rgba(35, 70, 92, 0.5)" strokeWidth="2"/>
          </svg>
          <div className="arrow-head"></div>
        </div>

        {/* Right Side - Content */}
        <div className="about-right">
          <h2 className="about-title">
            The Event House<br />
            Where Experiences Take Shape
          </h2>
          
          <p className="about-description">
            Event House is a modern event management company creating curated social, lifestyle, and experiential events. Mulaqaat is our signature launch experience — the first of many thoughtfully designed gatherings to come.
          </p>
          
          <p className="about-tagline">
            Some connections don't start with a swipe.<br />
            They start with a Mulaqaat.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
